import { App, Form } from "antd";
import { ExclamationCircleOutlined, DownOutlined } from "@ant-design/icons";

import { UserSelect } from "components/selects/user-select";
import { useMergeUsers } from "data/use-users";
import { useOnChange } from "hooks/use-on-change";
import { Modal } from "components/modal";

const onSubmit = ({ modal, mergeUsers }) => {
  return (values) => {
    modal.confirm({
      title: "Are you sure you want to merge these users?",
      icon: <ExclamationCircleOutlined />,
      content: "This cannot be undone!",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => mergeUsers.mutate(values),
    });
  };
};

export const MergeUsersModal = (props) => {
  const { close, isOpen } = props;

  const { modal } = App.useApp();
  const [form] = Form.useForm();

  const mergeUsers = useMergeUsers({
    onSuccess: close,
  });

  useOnChange(
    isOpen,
    () => {
      if (!isOpen) {
        return;
      }

      form.setFieldsValue({
        childIds: [],
        userId: null,
      });
    },
    [isOpen, form]
  );

  return (
    <Modal
      confirmLoading={mergeUsers.isLoading}
      okText="Merge"
      onCancel={close}
      onOk={form.submit}
      title="Merge Users"
      open={isOpen}
      width="750px"
    >
      <Form
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        onFinish={onSubmit({
          modal,
          mergeUsers,
        })}
      >
        <div style={{ marginBottom: "16px" }}>
          <strong>
            All accounts, open followups, and open opportunities will be reassigned from the source users to the destination user. The source users will then be archived.
          </strong>
        </div>
        <UserSelect
          label="sources"
          includeArchived
          name="childIds"
          labelKeyMap={(user) => {
            const { firstName, lastName, email } = user;

            let label = "";

            if (firstName && lastName) {
              label = `${firstName} ${lastName}`;
            } else if (firstName) {
              label = firstName;
            } else {
              label = lastName;
            }

            label = label + ` (${email})`;
            return label;
          }}
          groupBy={(options) => {
            const groups = options.reduce((acc, option) => {
              if (option.entity.isArchived) {
                if (!acc.archived) {
                  acc.archived = {
                    label: "Archived Users",
                    title: "archived",
                    options: [],
                  }
                }

                acc.archived.options.push(option);
              } else {
                if (!acc.notArchived) {
                  acc.notArchived = {
                    label: null,
                    title: "not-archived",
                    options: [],
                  }
                }

                acc.notArchived.options.push(option);
              }

              return acc;
            }, {});

            return [
              ...groups.notArchived?.options ?? [],
              ...(groups.archived ? [groups.archived] : []),
            ];
          }}
          rules={[{ min: 1, type: "array" }, { required: true }]}
          mode="multiple"
          placeholder="select source users to merge, these will be archived"
        />

        <div style={{ marginBottom: "24px", display: "flex", justifyContent: "center" }}>
          <DownOutlined />
        </div>

        <UserSelect label="destination" name="parentId" rules={[{ required: true }]}
          placeholder="select destination user"
        />
      </Form>
    </Modal>
  );
};
